<template>
  <div>
    <div
      class="ls-i"
      v-for="(item, index) in list"
      :key="index"
      @click="$router.push({ path: '/teacherDetails', query: { id: item.id } })"
    >
      <div class="top-n" v-if="index < 3">
        <img src="../../../assets/zx/0.png" alt="" v-if="index == 0" />
        <img src="../../../assets/zx/1.png" alt="" v-if="index == 1" />
        <img src="../../../assets/zx/2.png" alt="" v-if="index == 2" />
      </div>
      <div class="top-n-n" v-else>
        {{ index + 1 }}
      </div>
      <div class="ls-img">
        <van-image
          fit="cover"
          width="100%"
          height="100%"
          :src="item.avatar"
          alt=""
        />
      </div>
      <div class="ls-con">
        <p class="ls-name">{{ item.username }}</p>
        <div class="lable">
          <div v-for="(t, i) in item.modeArr" :key="i">{{ t }}</div>
        </div>
      </div>
      <div class="ls-aw-num">
        解答数：<span>{{ item.orderAllNum }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
@description:
@createTime:2021-09-17
@create:wq
*/
export default {
  name: "",
  props: ["list"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.ls-i {
  height: 1.8rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0.26rem 0;
  display: flex;
  align-items: center;
  &:last-child {
    border-bottom: none;
  }
  .top-n {
    flex-shrink: 0;
    width: 0.54rem;
    margin-right: 0.2rem;
    img {
      width: 100%;
    }
  }
  .top-n-n {
    flex-shrink: 0;
    width: 0.54rem;
    height: 0.54rem;
    margin-right: 0.2rem;
    background: #f0f0f0;
    border: 1px solid #e6e6e6;
    border-radius: 50%;
    font-size: 0.3rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ls-img {
    flex-shrink: 0;
    width: 1.28rem;
    height: 1.28rem;
    border: 2px solid #ffffff;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.1rem;

    img {
      width: 100%;
    }
  }
  .ls-con {
    flex: 1;

    .ls-name {
      font-size: 0.3rem;
      font-weight: bold;
      color: #333333;
    }
    .lable {
      display: flex;
      flex-wrap: wrap;
      margin-top: 4px;
      > div {
        padding: 2px 8px;
        height: 0.36rem;
        background: #ffeedf;
        border-radius: 0.22rem;

        font-size: 0.2rem;
        font-weight: 400;
        line-height: 40px;
        color: #ffa380;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.1rem;
        margin-top: 2px;
      }
    }
  }
  .ls-aw-num {
    flex-shrink: 0;
    font-size: 0.2rem;
    font-weight: bold;
    color: #cccccc;
    white-space: nowrap;
    span {
      font-size: 0.3rem;
      color: #999999;
    }
  }
}
</style>
